/* eslint-disable react/function-component-definition */
import { IConsentProgramHistory } from "@/Common/Api/Patient/Dto/IConsentProgramHistory";
import { ConsentStatus } from "@/Patient/Models/Consent/ConsentEnum";
import { ConsentPermission } from "@/Patient/Models/Consent/ConsentPermission";
import { XcomIcon } from "./XcomIcon";

import styles from "./XcomButton.module.scss";

interface IXcomButtonProps {
    className: string;
    disabled?: boolean;
    onClick: () => void;
    consentProgramHistory: Immutable.List<IConsentProgramHistory>;
}

const XcomButton: React.FC<IXcomButtonProps> = (props: IXcomButtonProps) => {
    const propsClass = props.className ? props.className.split(" ") : [];
    const cssClass = ["button", "patient-banner-button", styles.button, ...propsClass];

    const consentPermission = React.useMemo(() => {
        if (props.consentProgramHistory.count() === 0) {
            return ConsentPermission.NoActiveConsent;
        }

        const latestConsentProgram = props.consentProgramHistory.toArray()
            .sortByPropertyDesc(x => x.ConsentDate)[0];

        if (latestConsentProgram.Status === ConsentStatus.Consented) {
            return ConsentPermission.ConsentGiven;
        }

        if (latestConsentProgram.Status === ConsentStatus.Refused) {
            return ConsentPermission.ConsentRefused;
        }

        return ConsentPermission.NoActiveConsent;
    }, [props.consentProgramHistory]);

    cssClass.push(styles[consentPermission]);

    const cssClassName = cssClass.distinct().join(" ");

    return (
        <button
            className={cssClassName}
            onClick={() => props.onClick()}
            style={{ transform: "translate(0, 2px)" }}
            disabled={props.disabled}
        >
            <XcomIcon />
        </button>
    );
};

export { XcomButton };
